import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PagedFilter } from '../../models/components-general/general-filter.model';
import { GeneralService } from '../general.service';
import { Deadline, DeadlinesPaged } from '../../models/catalogs/deadline.model';
import { GeneralDTO } from '../../models/components-general/general-dto.model';



@Injectable({
    providedIn: 'root',
})
export class DeadlinesService {
    public URL_API = environment.apiURLNew;

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    public getDeadlines(pagedFilter: PagedFilter): Observable<DeadlinesPaged | null> {
        const params = this.generalService.buildParams(pagedFilter);
        return this.http
            .get<DeadlinesPaged>(this.URL_API + '/api/Deadline/GetPagedDeadlines', { params })
            .pipe(
                take(1),
                catchError(() => {
                    return of(null);
                }),
            );
    }

      public upsertDeadline(deadline: Deadline): Observable<GeneralDTO | null> {
        if (deadline.id) {
          return this.http.post<GeneralDTO>(this.URL_API + '/api/Deadline/UpsertDeadline', deadline).pipe(
            take(1),
            catchError(() => {
              return of(null);
            }),
          );
        }
        return this.http.post<GeneralDTO>(this.URL_API + '/api/Deadline/UpsertDeadline', deadline).pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        );
      }
}